"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportAsJcamp = exports.DataExportStage = exports.toJSON = exports.addJcamp = exports.DataExportOptions = void 0;
const file_saver_1 = require("file-saver");
const nmr_load_save_1 = require("nmr-load-save");
const Spectrum1D_1 = require("./data1d/Spectrum1D");
const Spectrum2D_1 = require("./data2d/Spectrum2D");
const Molecule = __importStar(require("./molecules/Molecule"));
var DataExportOptions;
(function (DataExportOptions) {
    DataExportOptions["ROW_DATA"] = "ROW_DATA";
    DataExportOptions["DATA_SOURCE"] = "DATA_SOURCE";
    DataExportOptions["NO_DATA"] = "NO_DATA";
})(DataExportOptions || (exports.DataExportOptions = DataExportOptions = {}));
function getData(datum, usedColors) {
    const dimension = datum.info.dimension;
    if (dimension === 1) {
        return (0, Spectrum1D_1.initiateDatum1D)(datum, { usedColors });
    }
    else if (dimension === 2) {
        return (0, Spectrum2D_1.initiateDatum2D)(datum, { usedColors });
    }
}
function addJcamp(output, jcamp, options, usedColors) {
    options = options || {};
    const name = options?.info?.name;
    const { spectra: spectraIn } = (0, nmr_load_save_1.processJcamp)(jcamp, {
        name,
        converter: {
            keepRecordsRegExp: /.*/,
            profiling: true,
        },
    });
    if (spectraIn.length === 0)
        return;
    const spectra = [];
    for (const spectrum of spectraIn) {
        const data = getData(spectrum, usedColors);
        if (!data)
            continue;
        spectra.push(data);
    }
    output.push(...spectra);
}
exports.addJcamp = addJcamp;
/**
 *
 * @param {object} state
 */
function toJSON(state, preferencesState, options = {}) {
    const { source, data = [], molecules: mols = [], correlations = {}, actionType = '', } = state;
    const { dataType = 'ROW_DATA', view = false, settings = false, serialize = true, exportTarget = 'nmrium', } = options;
    const molecules = mols.map((mol) => Molecule.toJSON(mol));
    const nmriumState = {
        version: nmr_load_save_1.CURRENT_EXPORT_VERSION,
        data: {
            ...(exportTarget === 'onChange' ? { actionType } : {}),
            source,
            spectra: data,
            molecules,
            correlations,
        },
        view: state.view,
        settings: preferencesState.current,
    };
    if (!serialize) {
        return nmriumState;
    }
    else {
        const includeData = dataType === 'ROW_DATA'
            ? 'rawData'
            : dataType === 'NO_DATA'
                ? 'noData'
                : 'dataSource';
        return (0, nmr_load_save_1.serializeNmriumState)(nmriumState, {
            includeData,
            includeSettings: settings,
            includeView: view,
        });
    }
}
exports.toJSON = toJSON;
exports.DataExportStage = {
    Original: 'ORIGINAL',
    Processed: 'PROCESSED',
};
function exportAsJcamp(spectrum, options = {}) {
    let jcamp = null;
    if ((0, Spectrum1D_1.isSpectrum1D)(spectrum)) {
        const { dataExportStage = 'PROCESSED', onlyReal } = options;
        const { originalData, originalInfo, data, info, filters } = spectrum;
        if (onlyReal && info.isFid) {
            throw new Error('FID data should be complex');
        }
        if (!originalData || !originalInfo) {
            throw new Error('original data should exists');
        }
        if (dataExportStage === 'PROCESSED') {
            jcamp = (0, nmr_load_save_1.spectrum1DToJcamp)({
                ...spectrum,
                data,
                info,
                filters,
            }, { onlyReal });
        }
        else {
            jcamp = (0, nmr_load_save_1.spectrum1DToJcamp)({
                ...spectrum,
                data: originalData,
                info: originalInfo,
                filters: [],
            }, { onlyReal });
        }
    }
    else {
        throw new Error('convert 2D spectrum to JCAMP is not supported');
    }
    if (!jcamp) {
        throw new Error('convert spectrum to JCAMP failed');
    }
    const blob = new Blob([jcamp], { type: 'text/plain' });
    (0, file_saver_1.saveAs)(blob, `${spectrum.info.name}.jdx`);
}
exports.exportAsJcamp = exportAsJcamp;
